module.exports = __webpack_public_path__ + "static/front-cover-7717e5d5d9998f59291c25d14d5cbe33.jpg";